import { rolesPermissionsMatrix, RolePermission } from './pathConfig';
import { MeFragment, MyRole } from '$/GraphQL/schema/schema';

const isMatchPath = (route: string, path: string): boolean => {
  const regex = new RegExp('^' + route.replace(/:[^\s/]+/g, '([A-Za-z0-9-\\-:\\+%]*)') + '+[/]?$');
  if (path.match(regex)) {
    return true;
  }
  return false;
};

const isMatchPaths = (routes: string[], path: string): boolean => {
  return routes.some((route: string) => {
    return isMatchPath(route, path);
  });
};

export const hasAddOnScope = (addOnScope: string, me: MeFragment): boolean => {
  const scopes = me.team.extraScopes?.split(',') ?? [];

  for (const scope of scopes) {
    if (scope && addOnScope.startsWith(scope)) {
      return true;
    }
  }

  return false;
};

export const hasScope = (path: string, me: MeFragment): boolean => {
  const rolePermission: RolePermission = Object.values(rolesPermissionsMatrix).find(
    (value: RolePermission) => value.path === path || isMatchPath(value.path, path)
  );
  if (!rolePermission || !rolePermission.scope) return true;

  const scopes = me.team.extraScopes?.split(',') ?? [];

  for (const scope of scopes) {
    if (scope && rolePermission.scope.startsWith(scope)) {
      return true;
    }
  }

  return false;
};

export const hasScopePermission = (scope: string, me: MeFragment): boolean => {
  const myScopes = me.team.extraScopes?.split(',') ?? [];

  for (const myScope of myScopes) {
    if (myScope && scope.startsWith(myScope)) {
      return true;
    }
  }

  return false;
};

const hasPermission = (path: string, me: MeFragment): boolean => {
  const rolePermission: RolePermission = Object.values(rolesPermissionsMatrix).find(
    (value: RolePermission) => value.path === path || isMatchPath(value.path, path)
  );
  if (!rolePermission) return true;

  if (!me) return false;

  let loggedUserRole = me.inTeam.role;
  if (me.inTeam.role === MyRole.Ops) {
    if (
      Object.entries(rolePermission.permission).find(
        ([role, value]: [string, boolean]) => value && role === me.inTeam.role
      )
    ) {
      return true;
    }

    loggedUserRole = MyRole.Admin;
  }

  return Object.entries(rolePermission.permission).find(
    ([role, value]: [string, boolean]) => value && role === loggedUserRole
  )
    ? true
    : false;
};

const getRolesHavePermission = (path: string): string[] => {
  const rolePermission: RolePermission = Object.values(rolesPermissionsMatrix).find(
    (value: RolePermission) => value.path === path || isMatchPath(value.path, path)
  );
  const roles =
    Object.entries(rolePermission.permission)
      .filter(([, value]: [string, boolean]) => value)
      .reduce((roles: string[], [key, value]: [string, boolean]) => {
        if (value) {
          roles.push(key);
        }
        return roles;
      }, []) || [];
  return roles;
};

export { isMatchPath, isMatchPaths, hasPermission, getRolesHavePermission };
